import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
  FETCH_ALL_CLUBS_REQUEST,
  FETCH_ALL_CLUBS_SUCCESS,
  FETCH_ALL_CLUBS_FAILURE,
  CREATE_CLUB_REQUEST,
  CREATE_CLUB_SUCCESS,
  CREATE_CLUB_FAILURE,
  EDIT_CLUB_REQUEST,
  EDIT_CLUB_SUCCESS,
  EDIT_CLUB_FAILURE,
  DELETE_CLUB_REQUEST,
  DELETE_CLUB_SUCCESS,
  DELETE_CLUB_FAILURE,
  FETCH_ALL_USERS_REQUEST,
  SET_LOADING_STATE,
  RESET_LOADING_STATE,
  CREATE_CATEGORY_REQUEST
} from "../constants";
import {
  firebaseFetchAllClubs,
  firebaseCreateClub,
  firebaseEditClub,
  firebaseDeleteClub,
} from "../api/api";

function* fetchAllClubsFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseFetchAllClubs(payload);
    if (response) {
      yield put({
        type: FETCH_ALL_CLUBS_SUCCESS,
        payload: { allClubs: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: FETCH_ALL_CLUBS_FAILURE });
      yield put({ type: RESET_LOADING_STATE });

    }
  } catch (err) {
    yield put({ type: FETCH_ALL_CLUBS_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* createClubFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseCreateClub(payload);
    if (response) {
      yield put({ type: CREATE_CLUB_SUCCESS, payload: { newClub: response } });
      yield put({ type: FETCH_ALL_USERS_REQUEST })
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: CREATE_CLUB_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_CLUB_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* editClubFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseEditClub(payload);
    if (response) {
      yield put({ type: EDIT_CLUB_SUCCESS, payload: { allClubs: response } });
      yield put({ type: FETCH_ALL_USERS_REQUEST })
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: EDIT_CLUB_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: EDIT_CLUB_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* deleteClubFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseDeleteClub(payload);
    if (response) {
      yield put({ type: DELETE_CLUB_SUCCESS, payload: { allClubs: response } });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: DELETE_CLUB_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: DELETE_CLUB_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

export default function* clubSaga(): SagaIterator {
  yield all([
    takeEvery(FETCH_ALL_CLUBS_REQUEST, fetchAllClubsFn),
    takeEvery(CREATE_CLUB_REQUEST, createClubFn),
    takeEvery(EDIT_CLUB_REQUEST, editClubFn),
    takeEvery(DELETE_CLUB_REQUEST, deleteClubFn),
  ]);
}
